import { component } from "picoapp";
import fetch from "unfetch";
import { getStoreCountryCode, isUK, isUSA } from "../lib/customerLocation";
import { createFocusTrap } from "focus-trap";
import { compensateADVisibility } from "../lib/focus-trap-utils";

const locationServiceUrl =
  "https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572";

const localStorageKey = "locationManuallySet";

async function getCustomerLocation() {
  const response = await fetch(locationServiceUrl);
  const data = await response.json();
  return data;
}

function customerOutsideRegionsWithStores(customerCountryCode) {
  return !["US", "GB", "CA"].includes(customerCountryCode);
}

function closeModal(node, trap) {
  node.classList.add("close");
  compensateADVisibility(node, false);
  trap.deactivate();
}

function showModal(node, trap) {
  node.classList.remove("close");
  compensateADVisibility(node, true);
  trap.activate();
  window.maestro.fireTrackEvent("viewCountrySelectionModal", {
    URL: window.location.href,
    path: window.location.pathname,
  });
}

function handleEscKey(event, node, trap) {
  if (event.key !== "Escape") return;
  if (node.classList.contains("close")) return;

  event.preventDefault();
  event.stopPropagation();
  closeModalPermanently(node, trap);
}

const modalDismissed = () => window.localStorage.getItem(localStorageKey);

function dismissModal() {
  window.localStorage.setItem(localStorageKey, getStoreCountryCode());
}

function closeModalPermanently(node, trap) {
  dismissModal();
  closeModal(node, trap);
}

function hasSkipParam() {
  const params = new URLSearchParams(window.location.search);
  return params.get("modal:geolocation") === "false";
}

export default component(async (node) => {
  const customersLocation = await getCustomerLocation();
  const storeCountryCode = getStoreCountryCode();
  const customerLocationMatchesStore =
    customersLocation.country_code === storeCountryCode;

  if (customersLocation.country_code === "GB" && !isUK()) {
    window.location.href = "//fromourplace.co.uk";
  }

  const trap = createFocusTrap(node, {
    allowOutsideClick: true,
    setReturnFocus: "nav[role=navigation] a[data-mtr-target=logo]",
    initialFocus: ".js-initial-focus",
  });

  if (
    hasSkipParam() ||
    modalDismissed() ||
    customerLocationMatchesStore ||
    (customerOutsideRegionsWithStores(customersLocation.country_code) &&
      isUSA())
  ) {
    return;
  }

  showModal(node, trap);

  const closeButton = node.querySelector(".geolocation-modal-close");
  closeButton.addEventListener("click", () => {
    closeModalPermanently(node, trap);
    window.maestro.fireTrackEvent("clickCountrySelectionModal", {
      URL: window.location.href,
      path: window.location.pathname,
      "click info": "X",
    });
  });

  const overlay = node.querySelector(".geolocation-modal-overlay");
  overlay.addEventListener("click", () => {
    closeModalPermanently(node, trap);
    window.maestro.fireTrackEvent("clickCountrySelectionModal", {
      URL: window.location.href,
      path: window.location.pathname,
      "click info": "outside",
    });
  });

  const countryOptionButton = node.querySelectorAll(
    ".geolocation-modal-country-option > a"
  );
  countryOptionButton.forEach((elem) => {
    elem.addEventListener("click", (event) => {
      const buttonURL = new URL(event.currentTarget.href);
      const countryCode = event.currentTarget
        .getAttribute("aria-label")
        .slice(0, 2);
      if (buttonURL.host === window.location.host) {
        event.preventDefault();
        dismissModal();
        closeModal(node, trap);
      }

      window.maestro.fireTrackEvent("clickCountrySelectionModal", {
        URL: window.location.href,
        path: window.location.pathname,
        "click info": countryCode,
      });
    });
  });

  window.addEventListener("keydown", (event) => {
    handleEscKey(event, node, trap);
    window.maestro.fireTrackEvent("clickCountrySelectionModal", {
      URL: window.location.href,
      path: window.location.pathname,
      "click info": "esc",
    });
  });
});
